import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  argumentField: "ORGN_DEV_NATN_CD_NM",
  commonSeries: null,
  valueField: "CLINIC_STEP_NAME",
  series: [
    {
      value: "0상",
      name: "0상",
      id: "0상",
    },
    {
      value: "1상",
      name: "1상",
      id: "1상",
    },
    {
      value: "2상",
      name: "2상",
      id: "2상",
    },
    {
      value: "3상",
      name: "3상",
      id: "3상",
    },
    {
      value: "4상",
      name: "4상",
      id: "4상",
    },
  ],
};

export const seriesSlice = createSlice({
  name: "series",
  initialState,
  reducers: {
    updateCommonSeriesSettings: (state, action) => {
      return {
        ...state,
        argumentField: action.payload.argumentField,
        commonSeries: action.payload.commonSeries,
        valueField: action.payload.valueField,
      };
    },

    updateArgumentField: (state, action) => {
      // state = {
      //   ...state,
      //   argumentField: action.payload,
      // };
      return {
        ...state,
        argumentField: action.payload,
      };
    },

    updateCommonSeries: (state, action) => {
      // state = {
      //   ...state,
      //   commonSeries: action.payload,
      // };
      return {
        ...state,
        commonSeries: action.payload,
      };
    },

    updateValueField: (state, action) => {
      // state = {
      //   ...state,
      //   valueField: action.payload,
      // };
      return {
        ...state,
        valueField: action.payload,
      };
    },

    updateSeries: (state, action) => {
      // state = {
      //   ...state,
      //   series: action.payload,
      // };
      return {
        ...state,
        series: action.payload,
      };
    },
  },
});

export const {
  updateCommonSeriesSettings,
  updateArgumentField,
  updateCommonSeries,
  updateValueField,
  updateSeries,
} = seriesSlice.actions;

export default seriesSlice.reducer;
